import { Label, TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import { EPaymentMethod } from 'types';

export const getPaymentMethodLabel = (
  paymentMethod: EPaymentMethod | undefined,
  t: TTranslator<TLocalesKeys>
): JSX.Element | null => {
  switch (paymentMethod) {
    case EPaymentMethod.CASH:
      return (
        <Label
          iconName="MoneyIcon"
          text={t('money.cash')}
          color="green"
          rounded
        />
      );
    case EPaymentMethod.CARD: {
      return (
        <Label
          iconName="CreditCardIcon"
          text={t('money.card')}
          color="blue"
          rounded
        />
      );
    }
    case EPaymentMethod.DEPOSIT: {
      return (
        <Label
          iconName="WalletIcon"
          text={t('money.deposit')}
          color="violet"
          rounded
        />
      );
    }
    case EPaymentMethod.BONUS: {
      return (
        <Label
          iconName="BonusIcon"
          text={t('bonuses')}
          color="orange"
          rounded
        />
      );
    }
    case EPaymentMethod.COMPOSITE: {
      return (
        <Label
          iconName="CompositeIcon"
          color="violetGradient"
          text={t('money.separated')}
          rounded
        />
      );
    }
    case EPaymentMethod.CLOUD_PAYMENTS: {
      return (
        <Label
          text="CloudPayments"
          color="red"
          iconName="CloudPaymentsIcon"
          rounded
        />
      );
    }
    case EPaymentMethod.POSTPAID: {
      return (
        <Label
          text={t('setting.post_payment')}
          color="gray-secondary"
          iconName="TimeForwardIcon"
        />
      );
    }
    case EPaymentMethod.TINKOFF_SBP: {
      return <Label text={t('sbp')} color="pink" iconName="SBPIcon" rounded />;
    }
    case EPaymentMethod.KASPI_QR: {
      return (
        <Label text="Kaspi qr" color="blue" iconName="KaspiIcon" rounded />
      );
    }
    case EPaymentMethod.KASPI_CARD: {
      return (
        <Label text="Kaspi card" color="blue" iconName="KaspiIcon" rounded />
      );
    }
    case EPaymentMethod.KASPI_PAY: {
      return (
        <Label text="Kaspi-онлайн" color="blue" iconName="KaspiIcon" rounded />
      );
    }
    case EPaymentMethod.STRIPE: {
      return (
        <Label
          text="Stripe"
          color="violet-stripe"
          iconName="StripeIcon"
          rounded
        />
      );
    }
    case EPaymentMethod.BEPAID_ERIP: {
      return (
        <Label
          text="bePaid"
          color="gray-secondary"
          iconName="BePaidIcon"
          rounded
        />
      );
    }

    default: {
      return null;
    }
  }
};

export const getTime = (
  t: TTranslator<TLocalesKeys>,
  minutes: number
): string => {
  const h = Math.floor(minutes / 60);
  const min = minutes % 60;

  if (h > 0 && min > 0) {
    return `${h} ${t('hour')} ${min} ${t('minute')}`;
  } else if (h > 0) {
    return `${h} ${t('hour')}`;
  } else return `${min} ${t('minute')}`;
};

export const formatSumPayment = (sum: number): string =>
  sum.toLocaleString(undefined, { maximumFractionDigits: 2 });
